import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Typography } from '@material-ui/core';
import { getGmailThreadUrl } from 'Helpers/External';
import ScheduleSendReminder
  from 'Components/AdvisorApp/Viewport/TodayDashboard/Reminders/ReminderSection/ScheduleSendReminder';
import { advisorPageMessages } from 'Consts/Strings';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { missionControlURL } from 'Hooks/useMissionControlURL';
import ReminderItem from './ReminderItem';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 50%',
    paddingRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  titleText: {
    fontWeight: 'bold',
    color: theme.palette.facet.primaryBlue,
  },
  seeMoreText: {
    fontWeight: 'bold',
    cursor: 'pointer',
    color: theme.palette.facet.primaryBlue,
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1, 0),
  },
});

const itemDisplayCount = 3;

const limitItems = (items, count) => (items.length > count ? items.slice(0, count) : items);

const ReminderSection = ({
  className,
  classes,
  title,
  reminderItems,
  refreshReminders,
  expanded,
}) => {
  const reminderTypeToHandler = {
    email: (reminder) => {
      const threadId = reminder.attr('relatedId');
      return getGmailThreadUrl(threadId);
    },
    message: reminder => missionControlURL(reminder, reminder.attr('householdId'), {
      calendarEventId: reminder.attr('meetingId'),
    }),
    meeting: reminder => missionControlURL(reminder, reminder.attr('householdId'), {}),
    birthday: reminder => missionControlURL(reminder, reminder.attr('householdId'), {}),
    anniversary: reminder => missionControlURL(reminder, reminder.attr('householdId'), {}),
    householdRecentMessage: reminder => buildPageLink(
      reminder?.relationship(fr.relationships.messagesPage.name)?.link('related'),
      advisorPageMessages,
      { householdId: reminder.attr('householdId') }, // params
    ),
  };

  const reminderItemsToDisplay = expanded ? reminderItems : limitItems(reminderItems, itemDisplayCount);
  if (reminderItems.length === 0) {
    return null;
  }
  return (
    <div className={classNames(classes.root, className)}>
      <Typography variant="h5" className={classes.titleText}>{title}</Typography>
      <div className={classes.itemContainer}>
        {reminderItemsToDisplay.map((reminder) => {
          const handleMarkAccurate = async (accurate) => {
            reminder.attr('accurate', accurate);
            await reminder.submit();
            refreshReminders();
          };

          if (reminder.attr('type') === 'schedule-send-meeting-agenda') {
            return (
              <ScheduleSendReminder reminder={reminder} refreshReminders={refreshReminders} />
            );
          }

          return (
            <ReminderItem
              onMarkAccurate={handleMarkAccurate}
              title={reminder.attr('description')}
              href={reminderTypeToHandler[reminder.attr('type')](reminder)}
            />
          );
        })}
      </div>
    </div>
  );
};

ReminderSection.defaultProps = {
  className: '',
};

ReminderSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  reminderItems: PropTypes.array.isRequired,
  refreshReminders: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ReminderSection);
